module.exports = __webpack_public_path__ + "img/mobile-logo.1e0a8aa7.png";